module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_7042.bc951db1.png";